var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Auth from "@aws-amplify/auth";
/**
 * Configures the AWS Auth Library with the given configuration
 *
 * @param {*} authConfig
 * @returns {AuthOptions}
 */
export var configure = function (authConfig) {
    return Auth.configure({
        region: authConfig.awsRegion,
        userPoolId: authConfig.userPoolId,
        userPoolWebClientId: authConfig.userPoolWebClientId,
        mandatorySignIn: false,
        storage: authConfig.storage
    });
};
/**
 * Signs in the user to AWS Cognito
 *
 * @param {string} email
 * @param {string} password
 * @returns
 */
export var signIn = function (email, password) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, Auth.signIn(email, password)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_1 = _a.sent();
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Signs out the user from Cognito
 *
 * @param {string} email
 * @param {string} password
 * @returns
 */
export var signOut = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Auth.signOut({ global: true })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Get the users current session if signed in.
 *
 * @returns
 */
export var getCurrentSession = function () {
    return Auth.currentSession();
};
/**
 * Send a request password reset email to the account
 *
 * @param {string} email
 * @returns
 */
export var requestPasswordReset = function (email) {
    return Auth.forgotPassword(email);
};
/**
 * Submit the users new password given the code that was sent via email
 *
 * @param {string} username The username of the user likely an email
 * @param {string} code The code emailed to the user to verify identity
 * @param {string} newPassword The password the user would like to use
 * @returns
 */
export var submitPasswordReset = function (username, code, newPassword) {
    return Auth.forgotPasswordSubmit(username, code, newPassword);
};
/**
 * Sets the new password when a user is in the FORCE_CHANGE_PASSWORD state
 *
 * @param {*} user use object from AWS amplify login result
 * @param {string} newPassword new password as a string
 * @returns
 */
export var completeNewPassword = function (user, newPassword) {
    return Auth.completeNewPassword(user, newPassword, {});
};
/**
 * Returns a valid idToken for the current user
 * If the token is expired it will be automatically refreshed
 *
 */
export var getToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                if (!isTokenExpired(currentSession)) return [3 /*break*/, 3];
                return [4 /*yield*/, refreshToken(currentSession)];
            case 2:
                //@ts-ignore
                currentSession = _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/, currentSession.getIdToken().getJwtToken()];
            case 4:
                error_2 = _a.sent();
                throw error_2;
            case 5: return [2 /*return*/];
        }
    });
}); };
/**
 * This will refresh the current session tokens if the token is due to expire in the next 5 minutes
 *
 * @param {CognitoUserSession} currentSession
 * @returns {boolean}
 */
export var isTokenExpired = function (currentSession) {
    try {
        var tokenExp = currentSession.getIdToken().getExpiration();
        return tokenExp <= Date.now() / 1000 + 300;
    }
    catch (error) {
        throw error;
    }
};
/**
 * Refreshes the current users session with new access and id tokens
 * This is done automatically in getToken() so you might not need to call this
 * @param {CognitoUserSession} currentSession
 */
export var refreshToken = function (currentSession) {
    return new Promise(function (resolve, reject) {
        Auth.currentAuthenticatedUser()
            .then(function (currentUser) {
            currentUser.refreshSession(currentSession.getRefreshToken(), function (err, session) {
                if (err !== null)
                    reject(err);
                else
                    resolve(session);
            });
        })
            .catch(function (err) {
            reject(err);
        });
    });
};
/**
 * Allows the currently logged in user to reset their password.
 */
export var changePassword = function (currentPassword, newPassword) { return __awaiter(void 0, void 0, void 0, function () {
    var user, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, Auth.currentAuthenticatedUser()];
            case 1:
                user = _a.sent();
                return [4 /*yield*/, Auth.changePassword(user, currentPassword, newPassword)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
